import React from 'react';
import { Typography } from '@mui/material';
import { useStyles } from './InternalStyle';

function Welcome(props) {
  const classes = useStyles();
  const userDetail = props.userDetails;

  return (
    <>
      <Typography variant="h5" className={classes.welcome}>
        Welcome! {userDetail.firstName}
      </Typography>
    </>
  );
}

export default Welcome;
